/**
 * @file        src/api/wallet.js
 * @description Customer wallet API: balance + buckets (dues), ledger, and
 *              self-recharge. Reads live on the /api/v3 account base (same as
 *              /me/profile); recharge initiate is on the /api/v1 base.
 * @author      Kinetika Labs
 * @created     2026-07-23
 * @changelog
 *   - 2026-07-23 Claude — Initial (customer wallet).
 */
import { get, post } from './client.js';

// Account reads are mounted under /api/v3 (hotelRoutes), mirroring travellers.js.
const V3 = { baseURL: (import.meta.env.VITE_API_BASE_URL || '/api/v1').replace(/\/v1$/, '/v3') };

/** Balance + live credit buckets (with expiry = "dues") + status. */
export async function getWallet() {
  return get('/me/wallet', V3);
}

/** Paginated ledger. Returns { data, total, page, pageSize }. */
export async function getWalletTransactions(params) {
  return get('/me/wallet/transactions', { ...V3, params });
}

/** Start a self top-up. Returns { success, txnid, amount, paymentUrl, ... }. */
export async function rechargeInitiate(body) {
  // Recharge routes live on the default /api/v1 base (route.js).
  return post('/wallet-recharge/initiate', body);
}
